import React, { Component } from "react";
import * as firebasedb from "./firebase/firebase";
import DeckGridRows from "./DeckBuilderComponents/DeckGridRows.js"
import AdChitika from "./Ads/AdChitika";


class Decks extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      dgdecks: []
    }

    this.load = this.load.bind(this);
    this.stateupdate = this.stateupdate.bind(this);
  }

  componentDidMount () {
    var decklist = this.state.dgdecks;
    var thethis = this;

    firebasedb.db.collection("deckDetails").get().then(function(querySnapshot) {
      querySnapshot.forEach(function(doc) {
        decklist.push(
          {"id": doc.id,
          "deckName": doc.data().deckName,
          "author": doc.data().author,
          "cardCount": doc.data().cardCount,
          "nanoCost": doc.data().nanoCost,
          "aspects": ("aspects" in doc.data() ? doc.data().aspects : []),
          "addDate": ("addDate" in doc.data() ? doc.data().addDate : new Date()),
          "upVotes": ("upVotes" in doc.data() ? doc.data().upVotes : 0),
          "Comments": ("Comments" in doc.data() ? doc.data().Comments.length : 0),
          "Gold": ("Gold" in doc.data() ? doc.data().Gold : 0),
          "Silver": ("Silver" in doc.data() ? doc.data().Silver: 0),
          "Bronze": ("Bronze" in doc.data() ? doc.data().Bronze: 0)
        });

      });
      thethis.stateupdate(decklist);
    });
  }

  stateupdate(data){
    this.setState({decklist: data})
  }


  load(event){
    //Not Currently Used
    var decklist = this.state.dgdecks;
    var thethis = this;

    firebasedb.db.collection("deckDetails").get().then(function(querySnapshot) {
      querySnapshot.forEach(function(doc) {
        decklist.push(
          {"id": doc.id,
          "deckName": doc.data().deckName,
          "author": doc.data().author,
          "cardCount": doc.data().cardCount,
          "nanoCost": doc.data().nanoCost,
          "aspects": ("aspects" in doc.data() ? doc.data().aspects : []),
          "addDate": ("addDate" in doc.data() ? doc.data().addDate : new Date()),
          "upVotes": ("upVotes" in doc.data() ? doc.data().upVotes : 0)
        });

          // doc.data() is never undefined for query doc snapshots
      //    console.log(doc.id, " => ", doc.data());
      });
      thethis.stateupdate(decklist);
    });

  }


  render() {
    var deckListStyle = {
      marginTop:"60px"
    };

    var deckStyle = {
      backgroundColor: "black",
      color: "white"
    }

    var adStyle={
      justifyContent: "center"
    }

    return (
      <div className="container" style={deckListStyle}>
      <div style={adStyle} className="row">
      <AdChitika publisher="Gaztingo" />
      </div>
      <div id="deck" className="d-flex flex-row flex-wrap">
          <table id="decklist" style={deckStyle} className="table table-sm">
              <thead>
                  <tr>
                  <th>Deck Name</th>
                  <th>Aspects</th>
                  <th>Author</th>
                  <th>Card Count</th>
                  <th>Nanobot Cost</th>
                  <th>Up Votes</th>
                  <th>Comments</th>
                  <th>Add Date</th>
                  <th>Trophies</th>
                  </tr>
              </thead>
              <tbody>
                <DeckGridRows dgdecks={this.state.dgdecks}/>
              </tbody>
              <tfoot>
              </tfoot>
          </table>

      </div>
      </div>
    );
  }
}

export default Decks;

/*
    <button type="button" className="btn" onClick={this.load} >Search</button>
*/



// WEBPACK FOOTER //
// ./src/Decks.js